import { render, staticRenderFns } from "./ModalSoilPreparation.vue?vue&type=template&id=0bb2b8db&scoped=true"
import script from "./ModalSoilPreparation.vue?vue&type=script&lang=js"
export * from "./ModalSoilPreparation.vue?vue&type=script&lang=js"
import style0 from "./ModalSoilPreparation.vue?vue&type=style&index=0&id=0bb2b8db&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2b8db",
  null
  
)

export default component.exports